export default __webpack_public_path__ + "static/media/fcv-lossinvalue.b83c6d28.svg";